// ============================================
// Leka — useAuth Hook
// ============================================
import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/shared/store/authStore'

export function useAuth() {
  const { user, isLoading, error, setUser, reset } = useAuthStore()
  const setUserRef = useRef(setUser)
  setUserRef.current = setUser

  useEffect(() => {
    const controller = new AbortController()

    async function fetchSession() {
      try {
        const res = await fetch('/api/auth/get-session', {
          credentials: 'include',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
        })
        if (!res.ok) { setUserRef.current(null); return }
        const data = await res.json()
        setUserRef.current(data?.user ?? null)
      } catch (e: unknown) {
        if ((e as { name?: string })?.name !== 'AbortError') setUserRef.current(null)
      }
    }

    fetchSession()
    return () => controller.abort()
  }, [])

  const signOut = async () => {
    try {
      await fetch('/api/auth/sign-out', {
        method: 'POST',
        credentials: 'include',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
      })
    } catch { /* ignore */ }
    reset()
  }

  return {
    user,
    isLoading,
    error,
    isAuthenticated: !!user,
    signOut,
  }
}
